import { createAiApi, type AiApi, type AiPref, type AiRequest } from '@foroba/ui'

/** Global fetch (see main.tsx) injects the Bearer token and rewrites to the native API base. */
const request: AiRequest = async (method, path, body) => {
  const res = await fetch(path, {
    method,
    headers: body === undefined ? undefined : { 'Content-Type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
  })
  if (!res.ok) throw new Error(`HTTP ${String(res.status)}`)
  return res.status === 204 ? undefined : res.json()
}

/** Each app owns its prefs proxy; the interceptor does not map `/api/ai`, so use versioned paths. */
const PREFS_URL: Record<string, string> = {
  pazuru: '/api/v1/pazuru/api/ai/prefs',
  tsumi: '/api/v1/tsumi/api/ai/prefs',
  foroba: '/jeli/ai/prefs',
}

/** Consents, BYOK keys and usage live behind Foroba's `/jeli/ai` proxy. */
const account = createAiApi(request, { account: '/jeli/ai' })

export const aiApi: AiApi = {
  ...account,
  getPrefs: async () => {
    const lists = await Promise.all(Object.values(PREFS_URL).map((u) => request('GET', u) as Promise<AiPref[]>))
    return lists.flat()
  },
  putPref: (pref) => {
    const url = PREFS_URL[pref.app]
    if (!url) return Promise.reject(new Error(`unknown AI app: ${pref.app}`))
    return request('PUT', url, pref) as Promise<AiPref>
  },
}

/** App Store 3.1.1: the iOS app never links to a purchase flow for AI quota. */
export const AI_UPGRADE_HREF: string | undefined = undefined
